const constants = {
    wazeUrl: 'https://www.waze.com/en/live-map/directions/br/sp/av.-dr.-francisco-junqueira,-990?navigate=yes&to=place.ChIJpYiWjf2-uZQRNJksx5mQf5s',
    whatsappUrl: 'https://wa.me/551636350101',
    instagramUrl: 'https://www.instagram.com/viamidia_rp/',
    facebookUrl: 'https://www.facebook.com/ViaMidiaComunicacaoVisual',
};
export default constants;
